function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';

import { loginStore as store, LoginActions as actions } from './LoginManager';

import BlockUi from 'react-block-ui';
import { Loader, Types } from 'react-loaders';
import 'react-block-ui/style.css';
import './loaders.min.css';

import { Reset } from './Reset';
import { New } from './New';

import './Login.css';

var logdown = require('logdown');
var console = logdown('rx-login-login', { prefixColor: '#689f38' });

export var Login = function (_Component) {
    _inherits(Login, _Component);

    function Login(props) {
        _classCallCheck(this, Login);

        var _this2 = _possibleConstructorReturn(this, _Component.call(this, props));

        _this2.onKeyPress = function (input, event) {

            if (event.key === 'Enter') {
                console.log('in okKeypress with input ' + input);
                if (input === 'username') {
                    console.log('move to password');
                    _this2.passwordInput.focus();
                } else if (input === 'password') {
                    console.log('submit');
                    _this2.handleLogin(event);
                }
            }
        };

        console.log('in Login with props: ' + JSON.stringify(props));

        _this2.loginTitle = "RX Login Component";

        if (_this2.props.loginTitle != null) {
            _this2.loginTitle = _this2.props.loginTitle;
        }

        _this2.state = {
            username: "",
            password: "",
            blocking: false,
            blockingMessage: '',
            blockingColor: '#000000',
            blockingClass: 'normal',
            resetModalOpen: false,
            newModalOpen: false,
            loginTitle: _this2.loginTitle
        };

        _this2.handleLogin = _this2.handleLogin.bind(_this2);
        _this2.handleChange = _this2.handleChange.bind(_this2);

        _this2.loginManager = props.loginManager;

        _this2.store = store;
        console.log('in Login.js with this.loginManager: ' + JSON.stringify(_this2.loginManager));

        var unsubscribe = _this2.store.subscribe(function () {

            var state = store.getState();
            console.log('APP loginStore state: ' + JSON.stringify(state));

            switch (state.state) {
                case actions.LOGIN_DONE:
                    console.log('login done - change to authenticated');
                    console.log('before history push: ' + _this2.props.history);
                    //this.props.history.push('/');
                    break;

                default:
                    break;
            }
        });
        //this.store.dispatch({type: actions.INIT});

        return _this2;
    }

    Login.prototype.componentDidMount = function componentDidMount() {
        this.usernameInput.focus();
    };

    Login.prototype.handleChange = function handleChange(event, field) {
        var _setState;

        console.log('field: ' + field);
        this.setState((_setState = {}, _setState[event.target.id] = event.target.value, _setState));
    };

    Login.prototype.handleLogin = function handleLogin(event) {

        event.preventDefault();
        this.setState({ blocking: true, blockingClass: 'normal', blockingMessage: 'Accedo' });
        var _this = this;

        var cb = function cb(success, failure) {

            console.log('called cb with success: ' + success + ' - and failure ' + failure);

            if (failure) {

                console.log('in failure: ' + JSON.stringify(failure));

                switch (failure.error) {

                    case "UserNotFoundException":
                    case "NotAuthorizedException":

                        _this.setState({ blocking: true, blockingMessage: 'UTENTE O PASSWORD NON VALIDI', blockingColor: '#000000', blockingClass: 'alertMessage' });
                        setTimeout(function () {

                            _this.setState({ blocking: false });
                            console.log('boo');
                        }, 1000);
                        break;

                    case "PasswordResetRequiredException":

                        console.log('in passwordResetRequiredExeption');
                        _this.setState({ resetModalOpen: true });
                        break;

                    case "NewPasswordRequired":

                        console.log('try to open newModal with NewPasswordRequired');

                        _this.setState({ newModalOpen: true });
                        break;

                    case "UserNotConfirmedException":

                        _this.setState({ blocking: true, blockingMessage: 'UTENTE NON AUTORIZZATO - CONTATTARE ADMIN', blockingColor: '#000000', blockingClass: 'alertMessage' });

                        setTimeout(function () {
                            _this.setState({ blocking: false });
                            console.log('boo');
                        }, 3000);
                        break;

                    default:

                        _this.setState({ blocking: true, blockingMessage: 'ERRORE GENERICO', blockingColor: '#000000', blockingClass: 'normal' });

                        setTimeout(function () {

                            _this.setState({ blocking: false });
                            console.log('boo');
                        }, 1000);
                        break;
                }
            }
        };

        console.log('in handleLogin');
        this.store.dispatch({ type: actions.LOGIN, username: this.state.username, password: this.state.password, cb: cb });
    };

    Login.prototype.render = function render() {
        var _this3 = this;

        return React.createElement(
            'div',
            { className: 'app flex-row align-items-center' },
            this.state.resetModalOpen && React.createElement(Reset, {
                isOpen: this.state.resetModalOpen,
                className: 'modal-success modal-lg ' + this.props.className,
                username: this.state.username,
                onConfirm: function onConfirm(data) {
                    console.log('on confirm with ' + JSON.stringify(data));
                    _this3.setState({ resetModalOpen: false, blocking: false, username: _this3.state.username, password: "" });
                    _this3.passwordInput.focus();
                }
            }),
            React.createElement(New, {
                isOpen: this.state.newModalOpen,
                className: 'modal-success modal-lg ' + this.props.className,
                loginstore: this.store,
                onConfirm: function onConfirm(data) {
                    console.log('on confirm with ' + JSON.stringify(data));
                    _this3.setState({ newModalOpen: false, blocking: false, username: "", password: "" });
                }
            }),
            React.createElement(
                Container,
                null,
                React.createElement(
                    Row,
                    { className: 'justify-content-center' },
                    React.createElement(
                        Col,
                        { md: '8' },
                        React.createElement(
                            BlockUi,
                            { tag: 'div', className: this.state.blockingClass, blocking: this.state.blocking, message: this.state.blockingMessage,
                                loader: React.createElement(Loader, { active: true, type: 'line-scale-pulse-out', color: this.state.blockingColor })
                            },
                            React.createElement(
                                CardGroup,
                                { className: 'mb-0' },
                                React.createElement(
                                    Card,
                                    { className: 'p-4' },
                                    React.createElement(
                                        CardBody,
                                        null,
                                        React.createElement(
                                            Row,
                                            null,
                                            React.createElement(
                                                Col,
                                                { xs: '12', sm: '12', lg: '12' },
                                                React.createElement(
                                                    'div',
                                                    { className: 'col-12 col-sm-12 col-lg-12' },
                                                    React.createElement('img', { src: "assets/img/logo.png", className: 'rounded mx-auto d-block' }),
                                                    React.createElement('br', null)
                                                ),
                                                React.createElement('br', null)
                                            )
                                        ),
                                        React.createElement('br', null),
                                        React.createElement(
                                            'h3',
                                            { className: 'pageDescription', style: { textAlign: 'center', color: 'grey' } },
                                            this.state.loginTitle
                                        ),
                                        React.createElement(
                                            'p',
                                            { className: 'text-muted-' },
                                            'Sign In to your account'
                                        ),
                                        React.createElement(
                                            InputGroup,
                                            { className: 'mb-3' },
                                            React.createElement(
                                                InputGroupAddon,
                                                { addonType: 'prepend' },
                                                React.createElement(
                                                    InputGroupText,
                                                    null,
                                                    React.createElement('i', { className: 'icon-user' })
                                                )
                                            ),
                                            React.createElement(Input, {
                                                type: 'text',
                                                innerRef: function innerRef(input) {
                                                    _this3.usernameInput = input;
                                                },
                                                placeholder: 'Username',
                                                id: 'username',
                                                value: this.state.username,
                                                onChange: this.handleChange,
                                                onKeyPress: function onKeyPress(e) {
                                                    return _this3.onKeyPress('username', e);
                                                }
                                            })
                                        ),
                                        React.createElement(
                                            InputGroup,
                                            { className: 'mb-4' },
                                            React.createElement(
                                                InputGroupAddon,
                                                { addonType: 'prepend' },
                                                React.createElement(
                                                    InputGroupText,
                                                    null,
                                                    React.createElement('i', { className: 'icon-lock' })
                                                )
                                            ),
                                            React.createElement(Input, {
                                                type: 'password',
                                                innerRef: function innerRef(input) {
                                                    _this3.passwordInput = input;
                                                },
                                                placeholder: 'Password',
                                                id: 'password',
                                                value: this.state.password,
                                                onChange: this.handleChange,
                                                onKeyPress: function onKeyPress(e) {
                                                    return _this3.onKeyPress('password', e);
                                                }
                                            })
                                        ),
                                        React.createElement(
                                            Row,
                                            null,
                                            React.createElement(
                                                Col,
                                                { xs: '6' },
                                                React.createElement(
                                                    Button,
                                                    { color: 'primary', className: 'px-4', onClick: this.handleLogin },
                                                    'Login'
                                                )
                                            ),
                                            React.createElement(
                                                Col,
                                                { xs: '6', className: 'text-right' },
                                                React.createElement(
                                                    'button',
                                                    { className: 'px-4 btn btn-primary' },
                                                    'Forgot password?'
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        );
    };

    return Login;
}(Component);